import React, { useEffect } from "react";
import "./style.scss";
import AccountDetails from "./AccountDetails";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useState } from "react";
import { getUser } from "../../../store/reducers/userSlice";
import { useDispatch } from "react-redux";

function GeneralInformation() {
  const userDetail = useSelector((state) => state.user);
  const [userDetails, setUserDetails] = useState(userDetail);
  const idToken = useSelector((state) => state.auth.idToken);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);
  const dispatch = useDispatch();

  useEffect(() => {
    setUserDetails(userDetail);
  }, [userDetail]);

  useEffect(() => {
    if (idToken) {
      dispatch(getUser({ idToken, selectedBrand }));
    }
  }, [idToken, selectedBrand, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="generalinfo">
      <div className="general-info-wrapper">
        <AccountDetails userDetails={userDetails} />
      </div>
    </div>
  );
}

export default GeneralInformation;
